import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-12010">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-12011">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12012">
          <ChevronLeftIcon size={16} data-id="element-12013" />
          <span data-id="element-12014">Card monitoring programs</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-12015">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-12016">
          Visa Acquirer Monitoring Program (VAMP)
        </h1>
        <p className="text-gray-600" data-id="element-12017">
          View your monitoring program status and history.
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-12018">
        <div className="flex items-center gap-2 mb-2" data-id="element-12019">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-12020">History</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-12021">
            <InfoIcon size={16} data-id="element-12022" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-12023">
          Your program history for the last 12 months.
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-12024">
          <table className="w-full" data-id="element-12025">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-12026">
              <tr data-id="element-12027">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-12028">
                  Program type
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-12029">
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-12030">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-12031">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-12032">
                  <div className="flex items-center gap-2" data-id="element-12033">
                    <span className="text-sm text-gray-900" data-id="element-12034">
                      Fraud and disputes
                    </span>
                    <div className="relative" data-id="element-12035">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-12036">
                        <InfoIcon size={14} data-id="element-12037" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-12038">
                          Measures fraud and disputes against the total number
                          of settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-12039"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-12040">
                    {index === 11 ? <div className="flex justify-center" data-id="element-12041">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-12042"></div>
                      </div> : <div className="flex justify-center" data-id="element-12043">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-12044"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-12045">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-12046">
                  <div className="flex items-center gap-2" data-id="element-12047">
                    <span className="text-sm text-gray-900" data-id="element-12048">Card testing</span>
                    <div className="relative" data-id="element-12049">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-12050">
                        <InfoIcon size={14} data-id="element-12051" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-12052">
                          Measures card testing against the total number of
                          settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-12053"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-12054">
                    {index === 11 ? <div className="flex justify-center" data-id="element-12055">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-12056"></div>
                      </div> : <div className="flex justify-center" data-id="element-12057">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-12058"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-12059">
        <div className="flex items-center gap-2 mb-2" data-id="element-12060">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-12061">
            Historical and current program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-12062">
            <InfoIcon size={16} data-id="element-12063" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-12064">
          Visa-identified fraud and disputes against the total number of settled
          payments
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-12065">
          <p className="text-center text-gray-500" data-id="element-12066">No past history found.</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-12067">
        <div className="flex items-center gap-2 mb-2" data-id="element-12068">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-12069">
            Estimated program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-12070">
            <InfoIcon size={16} data-id="element-12071" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-12072">
          Rabbit Gateway's estimate of your Visa frauds and disputes. Aim to
          keep your VAMP ratio under 0.5%.{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-12073">
            Learn more
          </a>{' '}
          about how to keep your disputes and fraud low.
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-12074">
          <p className="text-center text-gray-500" data-id="element-12075">No past history found.</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-12076">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-12077">Resources</h2>
        <div className="flex flex-wrap gap-4" data-id="element-12078">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12079">
            <ExternalLinkIcon size={14} data-id="element-12080" />
            Program overview
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12081">
            <ExternalLinkIcon size={14} data-id="element-12082" />
            Preventing fraud and disputes
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-12083">
            <ExternalLinkIcon size={14} data-id="element-12084" />
            Preventing card testing
          </a>
        </div>
      </div>
    </div>;
}